// extracted by mini-css-extract-plugin
export var whatsOnHolder = "WhatsOnBadge-module--whatsOnHolder--9b323";